import script from "./ContactP.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactP.vue?vue&type=script&setup=true&lang=js"

import "./ContactP.vue?vue&type=style&index=0&id=510b2985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510b2985"]])

export default __exports__